<template>
    <div class="action-tooltip-block">
        <span
            v-click-outside="hide"
            v-on:click="toggle"
            class="action-tooltip-value"
            :class="{'is-open': isOpen === true}"
        >
            <slot></slot>
        </span>
        <div v-if="isOpen === true" class="action-tooltip">
            <div class="fs11" v-if="label">{{label}}</div>
            <div class="input-group input-group-sm">
                <input type="text" v-model="editValue" class="form-control" :placeholder="placeholder">
                <span class="input-group-btn">
                    <button class="btn btn-default" type="button" v-on:click="change" v-html="button"></button>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';

    export default {
        props: {
            label: {
                type: String,
                default: '',
            },
            value: {
                type: String,
                default: '',
            },
            placeholder: {
                type: String,
                default: '',
            },
            button: {
                type: String,
                default: '<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>',
            },
        },
        data() {
            return {
                isOpen: false,
                editValue: this.value,
            };
        },
        methods: {
            toggle () {
                this.isOpen = !this.isOpen;
            },

            hide () {
                this.isOpen = false;
            },
            change() {
                this.$emit('save', {value: this.editValue});
                this.hide();
            },
        },
        mounted () {
            this.popupItem = this.$el
        },
        directives: {
            ClickOutside,
        },
        watch: {
            value: function() {
                this.editValue = this.value;
            },
        },
    }
</script>